module.exports = __webpack_public_path__ + "media/images/let-you-screen/apple-icon-777957b77864ba2742c4d2039081e386.svg";